import data from "../../../../../src/ActionList/ActionList.docs.json";
import { Avatar } from '@primer/react';
import { ActionList } from '@primer/react';
import { LinkIcon, AlertIcon, ArrowRightIcon } from '@primer/octicons-react';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import * as React from 'react';
export default {
  data,
  Avatar,
  ActionList,
  LinkIcon,
  AlertIcon,
  ArrowRightIcon,
  InlineCode,
  React
};